export default {
  USER_ID: 'user_k0ztuB6X7HrZZD4NrtRwT',
  TEMPLATE_ID: 'template_b4jo6af',
};
